{
  "name": "@opensteer/runtime-core",
  "version": "0.2.7",
  "description": "Shared semantic runtime for Opensteer local and cloud execution.",
  "license": "MIT",
  "type": "module",
  "sideEffects": false,
  "repository": {
    "type": "git",
    "url": "git+https://github.com/steerlabs/opensteer.git",
    "directory": "packages/runtime-core"
  },
  "bugs": {
    "url": "https://github.com/steerlabs/opensteer/issues"
  },
  "homepage": "https://github.com/steerlabs/opensteer/tree/main/packages/runtime-core#readme",
  "keywords": [
    "opensteer",
    "runtime",
    "agents",
    "browser-automation"
  ],
  "engines": {
    "node": ">=22"
  },
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      }
    }
  },
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "dependencies": {
    "@opensteer/browser-core": "workspace:*",
    "@opensteer/protocol": "workspace:*",
    "cheerio": "^1.1.2",
    "css-select": "^6.0.0",
    "domhandler": "^5.0.3",
    "prettier": "^3.8.1",
    "sharp": "^0.34.5",
    "skills": "^1.4.6"
  },
  "optionalDependencies": {
    "webcrack": "^2.15.1"
  },
  "devDependencies": {},
  "scripts": {
    "build": "tsup",
    "clean": "rimraf dist",
    "typecheck": "tsc --noEmit -p tsconfig.json"
  }
}
